import { useRef, useEffect, useMemo } from "react";
import { identify, track } from "@adsk/acs-web-analytics";
import { useOptionalUser } from "@adsk/alloy-provider/es/UserContext";
export var useAnalytics = function () {
    var user = useOptionalUser().data;
    // Note: The user object is asynchronously loaded - this means that it can be undefined
    // before a call is made to recordAnalyticEvent().
    // Every call to recordAnalyticEvent() should be captured and reported, even while the user is
    // loading.
    // Thus, create a buffer to capture events while the user object is loading.
    var analyticBuffer = useRef([]);
    // Create the function to record events
    // If the user is defined, it will call the track() function from acs-web-analytics.
    // If user is undefined, it will buffer the events.
    var recordAnalyticEvent = useMemo(function () {
        return user
            ? track
            : function (eventName, eventProperties) {
                return analyticBuffer.current.push([eventName, eventProperties]);
            };
    }, [user, analyticBuffer]);
    // Side effect - Once user is defined, clear the buffer by recording all of the buffered events
    useEffect(function () {
        if (user && user.analyticsId) {
            identify(user.analyticsId, user);
            analyticBuffer.current.forEach(function (_a) {
                var eventName = _a[0], eventProperties = _a[1];
                track(eventName, eventProperties);
            });
            // Reset analytics buffer
            analyticBuffer.current = [];
        }
    }, [user]);
    return recordAnalyticEvent;
};
